const domain = process.env.NODE_ENV === `development` ? `/dev` : `/api`

export {
    domain
}
